export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["السلسلة من"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلى"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رموز"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيمة غير مسموح بها"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحقل المطلوب"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحقق من الحقول"])}
}